import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CACHE_KEYS } from '../../constants/cache-keys';
import { LPMI_ROUTES } from '../../constants/routes';
import { CacheService } from '../cache.service';

@Injectable({ providedIn: 'root' })
export class HelpAreaInfoGuard implements CanActivate {
  constructor(private router: Router, private cacheService: CacheService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    // Update PAGE_PATH_CONTEXT cache for help-area-info routes before resolver runs
    // This ensures third-party navigation uses the same dealer-help-desk path as menu navigation
    const appName = route.paramMap?.get('appName');
    if (appName) {
      this.cacheService.addToCache(CACHE_KEYS.NAVIGATION.PAGE_PATH_CONTEXT, {
        routePath: 'help-area-info',
        appName,
        pagePath: 'dealer-help-desk',
      });
    }

    const token = this.cacheService.getFromCache(CACHE_KEYS.LOGIN.LOGIN_DATA);

    if (!token) {
      this.cacheService.addToCache(CACHE_KEYS.HELP_AREA_INFO.REDIRECT_URL, state.url);
      return this.router.createUrlTree(['/', LPMI_ROUTES.LOGIN.PATH], {
        queryParams: { helpAreaRedirectUrl: state.url },
      });
    }
    return true;
  }
}
